import { FormattedMessage } from 'react-intl'
import {KTSVG} from '../../../../../_metronic/helpers'
import {useListView} from '../core/ListViewProvider'

const ProjectReportsEditModalHeader = () => {
  const {itemIdForUpdate, setItemIdForUpdate, setFileModelList, setMainFile} = useListView()

  return (
    <div className='modal-header'>
      {/* begin::Modal title */}
      {!itemIdForUpdate ? <h2 className='fw-bolder'>{<FormattedMessage id="UPDATE.PROJECT.REPORT" />}</h2> 
                        : <h2 className='fw-bolder'>{<FormattedMessage id="ADD.PROJECT.REPORT" />}</h2>}
      {/* end::Modal title */}

      {/* begin::Close */}
      <div
        className='btn btn-icon btn-sm btn-active-icon-primary'
        data-kt-users-modal-action='close'
        onClick={() => {
          setItemIdForUpdate(undefined)
          setFileModelList([])
          setMainFile({})
        }}
        style={{cursor: 'pointer'}}
      >
        <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-1' />
      </div>
      {/* end::Close */}
    </div>
  )
}

export {ProjectReportsEditModalHeader}
